// extracted by mini-css-extract-plugin
export default {"container":"CKRkfVHAmI098AGwzNQG","tab":"zOJcHpLU6ZeP4B53JPJo","selectedTab":"IcQsAx5Bp5hvOnzaBEgP"};